import { render, staticRenderFns } from "./buffetCardReport.vue?vue&type=template&id=02ff2962&"
import script from "./buffetCardReport.vue?vue&type=script&lang=js&"
export * from "./buffetCardReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports